import { InfoPaneTopicId } from '../../services/ToolbarActionService';

/** Author-facing metadata for a Pattern section: guidance text and help-pane topic. */
export interface PatternSectionInfo {
  /** Guidance rendered beneath the section title. */
  readonly description: string;
  /** Topic to open in the info pane when the section's "Info" link is clicked. */
  readonly topicId: InfoPaneTopicId;
}

/**
 * Per-section author guidance and help topic, keyed by template section id
 * (see the Pattern template's `contentSections`). Sections without an entry
 * render no description and no info link.
 */
export const PATTERN_SECTION_INFO: Readonly<Record<string, PatternSectionInfo>> = {
  summary: {
    description:
      'Provide a summary and concise but complete description of the pattern and what it accomplishes. Include its outcome, primary technologies/systems, vendor/ISV/SI names.',
    topicId: 'pattern-summary',
  },
  architecture: {
    description: 'Provide a high-level architectural overview of the target architecture.',
    topicId: 'pattern-architecture',
  },
  assumption: {
    description:
      'What needs to be in place, purchased, or known to successfully use and implement the technology in this pattern.',
    topicId: 'pattern-prerequisites',
  },
  'best-practices': {
    description: 'Best practices for implementing this pattern.',
    topicId: 'pattern-general',
  },
  tools: {
    description:
      'List any and all non-AWS tools used for the deployment, with a brief description of it and its use. If there are multiple tools, consider whether a separate pattern for each tool is the simplest and most straightforward approach.',
    topicId: 'pattern-tools',
  },
  epics: {
    description:
      'Epics are high-level constructs that guide the user through the use of the pattern.',
    topicId: 'pattern-epics',
  },
  troubleshooting: {
    description:
      'List any errors that can occur when using this pattern and solutions or workarounds.',
    topicId: 'pattern-troubleshooting',
  },
  references: {
    description: 'It is useful to provide resources that you think it necessary, link to the page.',
    topicId: 'pattern-general',
  },
};
